import { useMutation } from '@tanstack/react-query';

import { addToExistEstimate } from '../handlers/addToExistEstimates';

export const useAddToExistEstimates = () =>
    useMutation({
        mutationKey: ['addToExistEstimates'],
        mutationFn: addToExistEstimate,
    });
